const toFormData = data => {
  if (!data) {
    return new FormData();
  }
  return Object.keys(data).reduce((formData, key) => {
    formData.append(key, data[key]);
    return formData;
  }, new FormData());
};
const send = (url, params) => {
  if (!params) {
    params = {};
  }
  if (!params.headers) {
    params.headers = {};
  }
  params.headers.Accept = "application/json";
  params.headers["X-Requested-With"] = "XMLHttpRequest";
  return fetch(url, params).then(response => {
    if (!response.ok) {
      return response.json().then(responseData => {
        throw responseData;
      });
    }
    if (Number(response.status) === 204) {
      return null;
    }
    try {
      return response.json().catch(() => null);
    } catch (jsonError) {
      return null;
    }
  });
};
export const sendAsFormData = (url, params) => {
  if (!params) {
    return send(url);
  }
  if (params.method && params.method !== "GET" && params.method !== "HEAD") {
    params.body = toFormData(params.body);
    if (params.headers) {
      delete params.headers["Content-Type"];
    }
  }
  return send(url, params);
};
export const getHTML = (url, params) => {
  if (!params) {
    params = {};
  }
  if (!params.headers) {
    params.headers = {};
  }
  params.headers.Accept = "text/html";
  params.headers["X-Requested-With"] = "XMLHttpRequest";
  return fetch(url, params).then(response => {
    if (!response.ok) {
      return response.text().then(responseData => {
        throw responseData;
      });
    }
    if (Number(response.status) === 204) {
      return "";
    }
    return response.text();
  });
};
export default send;
